export const CommonBreakpoints = {
	desktopXl: 1500,
	desktopL: 1300,
	tabletL: 1200,
	tabletP: 900,
	mobileL: 740,
	mobileP: 480,
	tinyP: 350,
	headerTablet: 1000,
};

export const useMediaQuery = () => ({
	maxTinyP: `max-width: ${CommonBreakpoints.tinyP}px`,
	maxMobileP: `max-width: ${CommonBreakpoints.mobileP}px`,
	maxMobileL: `max-width: ${CommonBreakpoints.mobileL}px`,
	maxTabletP: `max-width: ${CommonBreakpoints.tabletP}px`,
	maxTabletL: `max-width: ${CommonBreakpoints.tabletL}px`,
	maxDesktopL: `max-width: ${CommonBreakpoints.desktopL}px`,
	maxDesktopXl: `max-width: ${CommonBreakpoints.desktopXl}px`,
	minMobileP: `min-width: ${CommonBreakpoints.tinyP + 1}px`,
	minMobileL: `min-width: ${CommonBreakpoints.mobileP + 1}px`,
	minTabletP: `min-width: ${CommonBreakpoints.mobileL + 1}px`,
	minTabletL: `min-width: ${CommonBreakpoints.tabletP + 1}px`,
	minDesktopL: `min-width: ${CommonBreakpoints.tabletL + 1}px`,
	minDesktopXl: `min-width: ${CommonBreakpoints.desktopL + 1}px`,
});
